import { MutableRefObject } from 'react'
import { type EmojiClickData } from '@wellesley/emoji-picker'

type Props = {
  ref: MutableRefObject<HTMLTextAreaElement | HTMLInputElement | null>
  onSetText(v: string): void
}

const useAddEmojiHandler = ({ ref, onSetText }: Props) => {
  const onAddEmoji = ({ emoji, isCustom }: EmojiClickData) => {
    const emojiText = isCustom ? `:${emoji}:` : emoji

    const textarea = ref.current

    const cursorPosition = textarea?.selectionStart || 0
    const textBefore = textarea?.value.substring(0, cursorPosition)
    const textAfter = textarea?.value.substring(cursorPosition)

    if (textarea) {
      // Insert the emoji at the cursor position
      textarea.value = textBefore + emojiText + textAfter

      // Restore the cursor position
      const newCursorPosition = cursorPosition + emojiText.length
      textarea?.setSelectionRange(newCursorPosition, newCursorPosition)

      // Focus back on the textarea
      textarea.focus()
    }

    onSetText(textBefore + emojiText + textAfter)
  }

  return onAddEmoji
}

export default useAddEmojiHandler
